// ---------------------------------------------------------------------------------------------------------------------
// Polyfill for creating CustomEvents on IE9+
// @see https://roots.io/sage/docs/sage-compatibility/
// @see https://github.com/kumarharsh/custom-event-polyfill

import 'custom-event-polyfill';

// ---------------------------------------------------------------------------------------------------------------------
// Import external dependencies

window.$ = window.jQuery = require('jquery');
import 'bootstrap';

// ---------------------------------------------------------------------------------------------------------------------
// Import local dependencies

import Router from './lib/Router';
import Theme from './lib/Theme';
import common from './routes/index';

// ---------------------------------------------------------------------------------------------------------------------
// Populate router instance with DOM routes

const routes = new Router({
  common,
});

// ---------------------------------------------------------------------------------------------------------------------
// Load events and theme functions

$(document).ready(() => {
  routes.loadEvents();
  Theme.init();
});
